import type { Effect, Reducer } from 'umi';

import type { ProductDataType } from './data';
import { getProductDetail } from './service';
import type { TableListItem as ProductPriceTableListItem } from '@/pages/product-manage/product-price/data';
import { gerProductPriceByProductId } from '../product-price/service';
import { getProductSupplierCostsByProductId } from '../product-supplier-cost/service';
import type { TableListItem as ProductSupplierCostTableListItem } from '@/pages/product-manage/product-supplier-cost/data';

export interface StateType {
  product?: ProductDataType;
  prices?: ProductPriceTableListItem[];
  supplierCosts?: ProductSupplierCostTableListItem[];
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    get: Effect;
    getProductPrices: Effect;
    getProductSupplierCosts: Effect;
  };
  reducers: {
    save: Reducer<StateType>;
    saveProductPrices: Reducer<StateType>;
    saveProductSuppleirCosts: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'productModel',
  state: {
    product: undefined,
  },
  effects: {
    *get({ payload }, { call, put }) {
      const response = yield call(getProductDetail, payload);
      yield put({
        type: 'save',
        payload: response.data,
      });
    },
    *getProductPrices({ payload }, { call, put }) {
      const response = yield call(gerProductPriceByProductId, payload);
      yield put({
        type: 'saveProductPrices',
        payload: response.data,
      });
    },
    *getProductSupplierCosts({ payload }, { call, put }) {
      const response = yield call(getProductSupplierCostsByProductId, payload);
      yield put({
        type: 'saveProductSuppleirCosts',
        payload: response.data,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        product: action.payload,
      };
    },
    saveProductPrices(state, action) {
      return {
        ...state,
        prices: action.payload,
      };
    },
    saveProductSuppleirCosts(state, action) {
      return {
        ...state,
        supplierCosts: action.payload,
      };
    },
    clear() {
      return {
        product: undefined,
      };
    },
  },
};

export default Model;
